import { match } from 'ts-pattern'

export const couponApplyToastMessage = ({
  appliedCouponExist,
  selectedCouponExist,
}: {
  appliedCouponExist: boolean
  selectedCouponExist: boolean
}) => {
  return match({ appliedCouponExist, selectedCouponExist })
    .with({ appliedCouponExist: true, selectedCouponExist: true }, () => '할인이 적용되었어요')
    .with({ appliedCouponExist: true, selectedCouponExist: false }, () => '할인 적용이 취소되었어요')
    .with({ appliedCouponExist: false, selectedCouponExist: true }, () => '할인이 적용되었어요')
    .with({ appliedCouponExist: false, selectedCouponExist: false }, () => '')
    .exhaustive()
}
